import { simpleReducer } from '../reducerHelpers'

export default simpleReducer({
  default: null,
  OPEN_SIDE_NAV: 'PAYLOAD',
  CLOSE_SIDE_NAV: null,
  SET_CURRENT_BRANCH: null,
})



// WEBPACK FOOTER //
// ./src/reducers/ui/sideNav.js